import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageHero from "@/components/PageHero";
import { T } from "@/constants/testIds";

const CATEGORIES = [
  { slug: null, label: "All" },
  { slug: "god", label: "God" },
  { slug: "jesus", label: "Jesus" },
  { slug: "bible", label: "Bible" },
  { slug: "salvation", label: "Salvation" },
  { slug: "prayer", label: "Prayer" },
  { slug: "suffering", label: "Suffering" },
  { slug: "other-religions", label: "Other religions" },
];

export default function QAIndex() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState(null);

  useEffect(() => {
    const url = cat ? `/questions?category=${cat}` : "/questions";
    api.get(url).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, [cat]);

  return (
    <>
      <PageHero
        eyebrow="Questions & Answers"
        title="Honest questions, careful answers."
        subtitle="Bring your doubts, your curiosity, your objections. We take questions seriously — the Bible does, too."
      >
        <Link to="/contact#ask" className="btn-primary">Submit a question</Link>
      </PageHero>

      <section className="py-16 sm:py-24">
        <div className="container-editorial">
          <div className="flex flex-wrap gap-2 mb-10">
            {CATEGORIES.map((c) => (
              <button
                key={c.label}
                data-testid={`qa-filter-${c.slug || "all"}`}
                onClick={() => setCat(c.slug)}
                className={`px-4 py-2 text-xs uppercase tracking-widest border transition-colors ${
                  cat === c.slug
                    ? "bg-ink text-background border-ink"
                    : "border-border text-ink-muted hover:border-ink hover:text-ink"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {items.map((q) => (
              <Link
                key={q.id}
                to={`/questions/${q.slug}`}
                data-testid={T.questionCard(q.slug)}
                className="group paper-card p-8 hover:border-ink transition-colors flex flex-col"
              >
                <span className="eyebrow text-forest">{q.category}</span>
                <h3 className="font-serif text-2xl mt-3 text-ink group-hover:text-forest transition-colors" style={{ fontWeight: 500 }}>
                  {q.question}
                </h3>
                <p className="text-sm mt-4 text-ink-muted leading-relaxed flex-1">
                  {q.short_answer.length > 220 ? `${q.short_answer.slice(0, 220)}…` : q.short_answer}
                </p>
                <span className="mt-6 text-xs uppercase tracking-widest text-ink group-hover:text-forest">
                  Full answer →
                </span>
              </Link>
            ))}
            {items.length === 0 && <p className="text-ink-muted">No questions in this category yet.</p>}
          </div>
        </div>
      </section>
    </>
  );
}
